import PlaceDetails from './places';

export default PlaceDetails;
